import * as texts from "../../../resources/l10n/messages.properties";
import {setTexts} from './messages/MessageLoader';

setTexts('ru', texts);